module.exports = __webpack_public_path__ + "img/IMG_1873.53db71cc.jpg";